import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {KupciPanelaDropdownModel} from '../models/ProizvodnjaModel'

const API_URL = process.env.REACT_APP_API_URL
const DROPDOWN_API = `${API_URL}/getKupciPanelaDropdown`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for dropdown data.
export async function getKupciPanelaDropdown(partner = false) {
  try {

    return await axios.get<Array<KupciPanelaDropdownModel>>(
        DROPDOWN_API,
        {
          headers: headers,

          params: {
            partner: partner ? 1 : 0,
          },
        }
    )

  } catch (error) {

    console.error(
        'Error fetching Dropdown data:',
        error
    )

    throw error
  }
}
